/* eslint-disable import/prefer-default-export */
import cloneDeep from 'lodash.clonedeep';
import {
  FormTemplate,
  FormTemplateSection,
} from 'data/template/template.types';
import { Xtp } from 'data/xtp/xtp.types';
import setAllFieldsAsReadOnlyExcludingFields from 'shared/form/fields/setAllFieldsAsReadOnlyExcludingFields';

export type ListenersIpAddressPortsType = {
  [key:string]: string[],
}

export function adaptTemplateVisibilityMode(
  template: FormTemplate | undefined,
  mode: 'create' | 'edit' | 'view',
): FormTemplate | undefined {
  if (template == null) {
    return;
  }

  const clonedTemplate = cloneDeep(template);

  if (mode === 'view') {
    setAllFieldsAsReadOnlyExcludingFields(clonedTemplate, []);
  }

  return clonedTemplate;
}

export function adaptTemplateOptions(
  template: FormTemplate | undefined,
  xdp?: Xtp,
): FormTemplate | undefined {
  if (template == null) {
    return template;
  }

  return cloneDeep(template);
}

export function adaptXtpTemplate(
  template: FormTemplate,
): FormTemplate {

  const clonedTemplate = cloneDeep(template);

  clonedTemplate.key = Date.now().toString();
  clonedTemplate.formId = Date.now().toString();

  return clonedTemplate;
}

export function adaptFormData(
  data: Xtp,
): Xtp {

  return cloneDeep(data);
}

export function adaptXtpFormData(
  xdp: Xtp,
): Xtp {

  const clonedXtp = cloneDeep(xdp);

  return clonedXtp;
}
